import FormController from './FormController'

// =============== 档案公共行为 ==============
export default class CardController extends FormController{

 
}
